import { OrganizationsState } from "@idw-types/state/organizations-state";
import { OrganizationsActionTypes, OrganizationsActions } from "../actions/organizations-actions";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { updateEntityStatus } from "@utils/object-util";

export const initialOrganizationsState: OrganizationsState = {
    organizations: {
        isLoading: false,
        organizations: null
    }
};

export const organizationsReducer = (
    state: OrganizationsState = initialOrganizationsState,
    action: OrganizationsActions
): OrganizationsState => {
    switch (action.type) {
        // Organizations
        case OrganizationsActionTypes.SET_ORGANIZATIONS_LOADING:
            return {
                ...state,
                organizations: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationsState.organizations }
                        : { ...state.organizations }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationsActionTypes.SET_ORGANIZATIONS:
            return {
                ...state,
                organizations: {
                    organizations: action.payload.axnCompanies,
                    isLoading: false
                }
            };
        case OrganizationsActionTypes.ADD_ORGANIZATION:
            return {
                ...state,
                organizations: {
                    ...state.organizations,
                    organizations: state.organizations.organizations
                        ? [...state.organizations.organizations, action.payload.axnCompany]
                        : [action.payload.axnCompany]
                }
            };

        case OrganizationsActionTypes.UPDATE_ORGANIZATIONS: {
            return {
                ...state,
                organizations: {
                    ...state.organizations,
                    organizations: updateEntityStatus<AxnCompany, AxnCompany>(
                        state.organizations.organizations,
                        action.payload.updatedAxnCompany,
                        action.payload.accountState
                    )
                }
            }
        }
        default:
            return state;
    }
};